import { render, staticRenderFns } from "./FormDeleteDiscount.vue?vue&type=template&id=e1a28222&scoped=true"
import script from "./FormDeleteDiscount.vue?vue&type=script&lang=js"
export * from "./FormDeleteDiscount.vue?vue&type=script&lang=js"
import style0 from "./FormDeleteDiscount.vue?vue&type=style&index=0&id=e1a28222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a28222",
  null
  
)

export default component.exports